import { handle } from './wrapper.js'

const handler = (input, select) => {
  const { selectedIndex, selectedOptions } = select

  selectedOptions[selectedIndex].value = input.value
}

export default input => {
  handle(input, handler)
}